import { render, staticRenderFns } from "./SchoolSolutionLMS.vue?vue&type=template&id=426d6a8e&"
import script from "./SchoolSolutionLMS.vue?vue&type=script&lang=js&"
export * from "./SchoolSolutionLMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports